<template>
  <div class="reply">
    <div v-for="(item, index) in reply_list"
         :key="item.id"
         class="reply-content">
      <div class="reply-user">
        <div v-if="item.is_admin"
             class="reply-inline">{{ $t('Comment.CommentReply.merchant') }}</div>
        <div v-if="!item.is_admin"
             class="reply-inline">{{ item.user?.username }}</div>
        <div v-if="!item.is_admin && item.user_id == tenant_id"
             class="reply-inline">{{ $t('Comment.CommentReply.me') }}</div>
        <div v-if="item.index == 2"
             class="reply-user reply-inline">
          <div class="reply-text reply-inline">{{ $t('Comment.CommentReply.reply') }}</div>
          <div class="reply-inline">{{ !item.reply_user ? $t('Comment.CommentReply.merchant') : item.reply_user.username
          }}</div>
        </div>
        ：
        <div class="reply-inline"
             style="font-weight: normal;">{{ item.content }}</div>
      </div>
      <div class="reply-box"
           :class="show_box && show_id == item.id && commentFlag.showFlag == `reply${show_id}` ? 'reply-color' : ''"
           @click="reply(item)">
        <MessageOutlined class="comment-icon" />{{ $t('Comment.CommentReply.reply') }}
      </div>
      <div v-if="index == 1 && !props.isDetail && props.appendList.length > 2"
           class="reply-box"
           @click="detail">
        <FileSearchOutlined class="comment-icon" />{{ $t('Comment.CommentReply.viewDetails') }}
      </div>
    </div>

    <div v-if="show_box && commentFlag.showFlag == `reply${show_id}`"
         class="reply-footer">
      <a-textarea v-model:value="content_value"
                  autofocus
                  :placeholder="placeholder" />
      <a-button type="primary"
                @click="submitReply(props.commentId)">{{ $t('Comment.CommentReply.submitComment') }}</a-button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from "vue"
import { message } from 'ant-design-vue'
import { createReply } from "../api/index"
import { useRouter } from "vue-router"
import { commentStore } from "../CommentPlugin"
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const commentFlag = commentStore()
const router = useRouter()
const props = defineProps<{
  appendList: any
  createdAt: string
  commentId: number
  userId: number
  isDetail: boolean
  isCustom: boolean
  isAdmin: boolean
  pageSize: number
  current: number
}>()
const emits = defineEmits(['submitReply'])
const tenant = localStorage.getItem("user")
const tenant_id = JSON.parse(tenant || '').user.id
const content_value = ref<string>('')
const placeholder = ref<string>('')
const reply_user = ref<string>('')
const show_box = ref<boolean>(false)
const show_id = ref<number>()
const reply = (item: any) => {
  if (show_id.value == item.id || !show_id.value) {
    show_box.value = !show_box.value
  }
  if (commentFlag.showFlag != `reply${item.id}`) {
    show_box.value = true
  }
  const username = !item.user ? t('Comment.CommentReply.merchant') : item.user.username
  placeholder.value = t('Comment.CommentReply.reply') + username + '：'
  reply_user.value = item.user_id
  show_id.value = item.id
  commentFlag.showFlag = `reply${item.id}`
}
const submitReply = async (id: number) => {
  if (!content_value.value) {
    message.error(t('Comment.CommentReply.enterCommentMessage'))
  }
  const data = {
    content: content_value.value,
    reply_user_id: reply_user.value,
    is_admin: props.isAdmin,
    comment_id: id,
    index: 2,
    reply_id: show_id.value
  }
  await createReply(id, data)
  emits('submitReply')
  show_box.value = false
}

const detail = () => {
  const data = {
    offset: props.current,
    limit: props.pageSize,
  }
  sessionStorage.setItem('spuCommentData', JSON.stringify(data))
  router.push({
    path: `/console/accounts/comment/${props.commentId}`,
    query: { from: props.isCustom ? 'custom' : 'comment' }
  })
}
const reply_list = computed(() => {
  return props.isDetail ? props.appendList : props.appendList.slice(0, 2)
})
</script>

<style scoped lang="less">
.reply {
  margin-top: 20px;

  .reply-content {
    line-height: 22px;

    .reply-user {
      display: inline;
      font-weight: bold;
      text-wrap: wrap;
    }

    .reply-inline {
      display: inline;
      word-break: break-all;
    }

    .reply-text {
      color: #999;
      font-weight: normal;
      margin: 0 5px;
    }

    .reply-box {
      display: inline;
      margin-left: 20px;
      cursor: pointer;
      color: #999;
    }

    .reply-color {
      color: #111;
    }

    .comment-icon {
      margin-right: 5px;
    }
  }

  .reply-footer {
    display: flex;
    margin-top: 20px;
    background-color: #f6f6f6;

    .ant-input {
      flex: 1;
      height: 64px;
      background: #f6f6f6;
    }

    .ant-btn {
      width: 64px;
      height: 64px;
      text-wrap: wrap;
    }
  }

}
</style>
